<div class="p-payment-method-finance">
  <div class="p-payment-method-finance__item">
    <span class="u-visually-hidden" [innerHTML]="'label.selectBank' | staticMsg"></span>
    <h3
      class="p-payment-method-finance__item-title p-payment-method-finance__item-title--m"
      [innerHTML]="'label.selectBank' | staticMsg"
    ></h3>
    <div class="p-payment-method-finance__item-contents">
      <div class="p-payment-method-finance__item-block" [formGroup]="bankFormGroup">
        <div class="p-payment-method-finance__item-block-box p-payment-method-finance__item-block-box--select">
          <div class="c-form-element-select c-form-element-select--non-label is-selected">
            <div class="p-input-block01__row-body-item-box">
              <label for="payment-input-internet-banking-select-1" class="c-form-element-select__label"
                ><span class="c-form-element-select__label-text" [innerHTML]="'label.selectBank' | staticMsg"></span
              ></label>
              <asw-select
                id="payment-input-internet-banking-select-1"
                formControlName="currentBank"
                (change$)="bankChange()"
                name="payment-input-internet-banking-select-1"
                aria-invalid="false"
              >
                <option value="" [innerHTML]="'placeholder.pleaseSelect' | staticMsg"></option>
                <option *ngFor="let bank of availableBankList" value="{{ bank.bank_code }}">
                  {{ bank.bank_name }}
                </option>
              </asw-select>
            </div>
          </div>
        </div>
      </div>
      <div class="p-payment-method-finance__item-block" *ngIf="amcBasic && this.isRealLogin">
        <div class="c-form-element-checkbox">
          <div class="c-form-element-checkbox__wrap">
            <label for="payment-input-internet-banking-checkbox-1" class="c-form-element-checkbox__label">
              <asw-checkbox
                id="payment-input-internet-banking-checkbox-1"
                [formControl]="saveAsUsualCheckboxControl"
                [label]="'label.saveAsUsualPaymentMthod' | staticMsg"
                (change$)="update()"
              ></asw-checkbox>
              <span class="u-visually-hidden" [innerHTML]="'label.saveAsUsualPaymentMthod' | staticMsg"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
